import React from 'react';
import { FaArrowRight } from 'react-icons/fa';
import styles from './style.module.scss';
import logo from '../../assets/logo.png';
import { IoCardOutline } from 'react-icons/io5';
import { MdOutlinePix } from 'react-icons/md';
import { BsUpcScan } from 'react-icons/bs';
import { Link, useNavigate } from 'react-router-dom';

const FooterComponent = () => {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
  };

  const handleExternalLink = (url) => {
    window.open(url, '_blank', 'noopener noreferrer');
  };

  return (
    <footer className={styles.container}>
      <div className={styles.containerRow}>
        {/* Logo Section */}
        <div className={styles.logoSection}>
          <Link to="/" className={styles.logoLink}>
            <img src={logo || "/placeholder.svg"} alt='Logo da empresa' className={styles.logo} />
          </Link>
        </div>

        {/* Jogos Section */}
        <div className={styles.footerColumn}>
          <h3 className={styles.columnTitle}>Jogos</h3>
          <div className={styles.linksList}>
            <button 
              className={styles.footerButton} 
              onClick={() => handleNavigation('minha-conta')}
            >
              Minha Conta
            </button>
            <button 
              className={styles.footerButton} 
              onClick={() => handleNavigation('saldo')}
            >
              Inserir Créditos
            </button>
            <button 
              className={styles.footerButton} 
              onClick={() => handleNavigation('/')}
            >
              Bolões
            </button>
          </div>
        </div>

        {/* Sobre a empresa Section */}
        <div className={styles.footerColumn}>
          <h3 className={styles.columnTitle}>Sobre a empresa</h3>
          <div className={styles.linksList}>
            <button 
              className={styles.footerButton} 
              onClick={() => handleNavigation('conheca')}
            >
              Quem somos
            </button>
            <button 
              className={styles.footerButton}
              onClick={() => handleExternalLink('https://sojogosonline.com.br/')}
            >
              Blog
            </button>
          </div>
        </div>

        {/* Suporte Section */}
        <div className={styles.footerColumn}>
          <h3 className={styles.columnTitle}>Suporte</h3>
          <div className={styles.linksList}>
            <button 
              className={styles.footerButton}
              onClick={() => handleExternalLink('https://api.whatsapp.com/send?phone=5534992016683&text=Ol%C3%A1!%20Gostaria%20de%20saber%20mais%20informa%C3%A7%C3%B5es.')}
            >
              Fale Conosco
            </button>
            <button 
              className={styles.footerButton} 
              onClick={() => handleNavigation('conheca')}
            >
              Como Funciona
            </button>
            <button 
              className={styles.footerButton} 
              onClick={() => handleNavigation('politica-de-privacidade')}
            >
              Política de Privacidade
            </button>
            <button 
              className={styles.footerButton} 
              onClick={() => handleNavigation('termos-de-uso')}
            >
              Termos de Uso
            </button>
          </div>
        </div>

        {/* Payment Methods Section */}
        <div className={styles.paymentSection}>
          <h3 className={styles.columnTitle}>Formas de Pagamento</h3>
          <div className={styles.containerPayments}>
            <div className={styles.paymentMethod}>
              <IoCardOutline className={styles.paymentIcon} />
              <div className={styles.paymentText}>
                <span className={styles.paymentLabel}>Cartão de</span>
                <span className={styles.paymentType}>Crédito</span>
              </div>
            </div>
            <div className={styles.paymentMethod}>
              <MdOutlinePix className={styles.paymentIcon} />
              <div className={styles.paymentText}>
                <span className={styles.paymentLabel}>Transferência</span>
                <span className={styles.paymentType}>Pix</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright Section */}
      <div className={styles.copyrightSection}>
        <div className={styles.copyrightContent}>
          <p>&copy; 2024 Tribo da Sorte. Todos os direitos reservados.</p>
          <div className={styles.socialLinks}>
            <span>Siga-nos nas redes sociais</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterComponent;
